import { IFormKey } from "src/app/modules/shared/models/forms";

export const home_form_keys: IFormKey[] = [
    {
        id: 'ndg-field',
        controlName: 'ndg',
        label: 'NDG',
        css: 'col-12'
    }
]

export const home_form_template = {
    ndg: ''
}

export const HOME_OPERATIONS_LIMIT = 15;

const isExtraMessageVisible = (() => {
  const now = new Date();

  // 13/04/2026 00:00:00 -> 20/04/2026 00:00:00 (20 escluso)
  const start = new Date(2026, 3, 13, 0, 0, 0, 0); // Aprile = 3
  const end = new Date(2026, 3, 20, 0, 0, 0, 0);

  return now >= start && now < end;
})();

/**
 * "type" field is the type of the Material Icon to be displayed
 */
export const HOME_ALERT_MESSAGES: Record<string, string>[] = [
    ...(isExtraMessageVisible ? [{
        type: 'error',
        message: 'Per interventi di manutenzione programmata, i sistemi di Athora Italia <strong>NON saranno disponibili</strong> per l’intera giornata di <strong>venerdì 17/04/2026</strong> e per tutto il fine settimana.<br/><strong>Il ripristino dei servizi è previsto per lunedì 20/04/2026.</strong>'
    }] : []),
    {
        type: 'warning',
        message: 'L\'operazione di <strong>"Switch"</strong> di Athora non è al momento disponibile sulla BPER Suite. Per procedere con l\'operatività manuale puoi scaricare i moduli dedicati nella sezione Menù - Documenti (in alto a sinistra) e inviarli tramite mail all\'indirizzo: <u>assistenza@athora.it</u>. Come da istruzioni operative inviare i moduli cartacei per posta interna.'
    },
    {
      type: 'info',
      message: 'In caso di problematiche tecniche che impediscano l\'inserimento delle operazioni a sistema <strong> è necessario aprire un ticket dedicato</strong> tramite la procedura BHELP, seguendo il consueto percorso.'
    },
]
